import React from 'react';

const competitorLabels = {
  garmin: 'Garmin',
  apple_watch: 'Apple Watch',
  polar: 'Polar',
  suunto: 'Suunto',
  whoop: 'Whoop',
  fitbit: 'Fitbit',
  wahoo: 'Wahoo',
  hammerhead: 'Hammerhead',
  oura: 'Oura',
};

export function CompetitorBadge({ competitor }) {
  const label = competitorLabels[competitor] || competitor;

  return (
    <span className="inline-flex items-center px-2 py-0.5 bg-coros-status-warning-bg text-coros-status-warning text-xs rounded font-medium">
      {label}
    </span>
  );
}

export function CompetitorBadges({ competitors, max = 3 }) {
  if (!competitors || competitors.length === 0) {
    return null;
  }

  const displayed = competitors.slice(0, max);
  const remaining = competitors.length - max;

  return (
    <div className="flex items-center flex-wrap gap-1">
      {displayed.map((competitor) => (
        <CompetitorBadge key={competitor} competitor={competitor} />
      ))}
      {remaining > 0 && (
        <span className="text-xs text-coros-text-muted">+{remaining} more</span>
      )}
    </div>
  );
}

export default CompetitorBadge;
